export default __webpack_public_path__ + "static/or-logo-1d0e07377729ebc9afe54e970ace5f54.png";